import { render, staticRenderFns } from "./CreditReportAccountView.vue?vue&type=template&id=2844f933&"
import script from "./CreditReportAccountView.vue?vue&type=script&lang=js&"
export * from "./CreditReportAccountView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports